import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "../features/common/headerSlice";
import modalSlice from "../features/common/modalSlice";
import rightDrawerSlice from "../features/common/rightDrawerSlice";

import { apiSlice } from "./apiSlice";
import teacherClassesSlice from "../classes/teacherClassesSlice";
import authReducer from "./authSlice";
import { setupListeners } from "@reduxjs/toolkit/query";

const combinedReducer = {
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  teacherClasses: teacherClassesSlice,
  auth: authReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
};

const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware), // Add the API middleware
});

setupListeners(store.dispatch);
export default store;
